import gql from 'graphql-tag';

export const InviteUser = gql`
  mutation InviteUser($request: InviteUserRequest!) {
    inviteUser(request: $request) {
      id
    }
  }
`;
